import Link from "next/link";
import React from "react";

export default function ButtonLink({ href, title, type = "primary" }) {
  const buttonClass = {
    primary:
      "inline-block py-3 px-10 bg-primary font-medium rounded no-underline hover:text-current",
    secondary:
      "inline-block py-3 px-10 bg-white text-primary font-medium border border-gray-300 rounded no-underline hover:text-current",
  };

  return (
    <Link href={href} className={buttonClass[type]}>
      {title}
    </Link>
  );
}
